export default __webpack_public_path__ + "static/media/rocks.38d1700b.png";